import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MdEmail } from "react-icons/md";
import logo from "../asset/logowhite.png";
import loginbg from "../asset/login/login.png";
import SummaryApi from "../common";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaArrowLeft } from "react-icons/fa";
const InstructorEmail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [email, setEmail] = useState(location.state?.login_identifier || "");
const [loading, setLoading] = useState(false);

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
    
  //   try {
  //     const response = await fetch(SummaryApi.instructorpasswordverification.url, {
  //       method: SummaryApi.instructorpasswordverification.method,
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({ email: email }),
  //     });

  //     const data = await response.json();

  //     if (data.status) {
  //       // toast.success(`Your OTP is ${data.otp}`);
  //       localStorage.setItem("instructor_email", email);
  //       localStorage.setItem("instructor_otp", data.otp);
  // const mobile = sessionStorage.getItem("instructor_mobile");
  // if (mobile && data.otp) {
  //   sendSmsOtp(mobile, data.otp);  
  // }
  //       setTimeout(() => {
  //         navigate("/instructor-otp");
  //       }, 800);
  //     } else {
  //       toast.error(data.message || "Invalid email");
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //     toast.error("Something went wrong. Please try again.");
  //   }
  // };


const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true); // start loading

  try {
    const response = await fetch(SummaryApi.instructorpasswordverification.url, {
      method: SummaryApi.instructorpasswordverification.method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: email }),
    });

    const data = await response.json();

    if (data.status) {
      localStorage.setItem("instructor_email", email);
      localStorage.setItem("instructor_otp", data.otp);
      const mobile = sessionStorage.getItem("instructor_mobile");
      if (mobile && data.otp) sendSmsOtp(mobile, data.otp);

      setTimeout(() => {
        setLoading(false);
        navigate("/instructor-otp");
      }, 800);
    } else {
      toast.error(data.message || "Invalid email");
      setLoading(false);
    }
  } catch (error) {
    console.error("Error:", error);
    toast.error("Something went wrong. Please try again.");
    setLoading(false);
  }
};


  const sendSmsOtp = async (mobileNumber, otpValue) => {

    const smsUrl = `https://sms.nettyfish.com/api/v2/SendSMS?SenderId=OAKYA&TemplateId=1707173313269381321&Message=Dear%20User%20your%20OTP%20${otpValue}%20for%20accessing%20admin%20panel%20-Oakya&PrincipleEntityId=1701172795416066262&ApiKey=ktTxImpILf3IA3lAdLt3sxLwpf0GUx41h9y%2BhU1LaWU=&ClientId=12eae6c0-7738-4f2a-afbe-77888ae20d0f&MobileNumbers=${mobileNumber}`;
    try {
      await fetch(smsUrl, {
        method: "GET",
        mode: "no-cors",
      });
      console.log("SMS Request Sent");
      return true;
    } catch (error) {
      console.error("SMS Error", error);
      return false;
    }
  };


  return (
    <div className="min-h-screen w-full bg-white flex items-center justify-center">
              <button
          onClick={() => window.history.back()}
          className="fixed top-10 left-4 z-50 flex items-center justify-center w-12 h-12 bg-white rounded-full shadow-lg hover:shadow-xl transition-all border border-gray-200 dark:bg-gray-800 dark:border-gray-700"
          aria-label="Go back"
        >
          <FaArrowLeft className="text-2xl text-[#103b6b] dark:text-white" />
        </button>
      <div className="w-full max-w-7xl min-h-[650px] flex rounded-3xl overflow-hidden shadow-lg">
             <div className="w-full md:w-1/2 h-64 md:h-auto relative">
          <img 
            src={loginbg} 
            alt="Instructor Background" 
            className="absolute inset-0 w-full h-full object-cover" 
          />
          <div className="absolute inset-0 bg-black bg-opacity-30" />
          <div className="relative z-10 flex items-center justify-center h-full">
            {/* Clickable Logo */}
            <div
              onClick={() => navigate("/", { replace: true })}
              className="cursor-pointer transition-transform duration-200 hover:scale-105"
              title="Go to Home"
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && navigate("/", { replace: true })}
            >
              <img src={logo} alt="Logo" className="w-40 md:w-64" />
            </div>
          </div>
        </div>

        <div className="w-1/2 bg-white flex items-start justify-center pt-6 px-10">
          <div className="w-full max-w-md">
            <h2 className="text-[45px] font-bold text-blue-900 mb-6 text-center font-inter">
              Verify Your Email!
            </h2>
            <form className="space-y-6 items-center mt-[20%]" onSubmit={handleSubmit}>
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700 font-inter mb-1"
                >
                  Email
                </label>
                <div className="relative">
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 pl-10"
                    required
                  />
                  <MdEmail className="absolute left-3 top-2/4 transform -translate-y-1/2 text-gray-400 text-xl" />
                </div>
              </div>
      <button
  type="submit"
  className="w-full py-3 bg-blue-900 hover:bg-blue-800 text-white font-semibold rounded-lg shadow-md transition duration-200 font-inter flex justify-center items-center gap-2"
  disabled={loading} // disable while loading
>
  {loading ? (
    <>
      <svg
        className="animate-spin h-5 w-5 text-white"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v8H4z"
        ></path>
      </svg>
      Loading...
    </>
  ) : (
    "NEXT"
  )}
</button>

            </form>

            <p className="mt-6 text-sm text-center text-gray-600 font-inter">
              Not a member?{" "}
              <a
                href="/instructor-signup"
                className="text-blue-900 font-medium hover:underline font-inter"
              >
                sign up
              </a>
            </p>
          </div>
        </div>
      </div>
      <ToastContainer position="top-center" autoClose={3000} />
    </div>
  );
};

export default InstructorEmail;